import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const LoadingBar: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const location = useLocation();

  useEffect(() => {
    // Start loading when location changes
    setIsLoading(true);
    setProgress(10);

    // Simulate progress
    const timer1 = setTimeout(() => {
      setProgress(50);
    }, 100);
    const timer2 = setTimeout(() => {
      setProgress(90);
    }, 200);
    const timer3 = setTimeout(() => {
      setProgress(100);
      setTimeout(() => {
        setIsLoading(false);
        setProgress(0);
      }, 200);
    }, 300);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [location]);

  if (!isLoading) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-1 z-[100] pointer-events-none">
      <div
        className="h-full bg-gradient-to-r from-brand-secondary to-brand-primary-dark transition-all duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};
